// FAQ accordion: clicking a question toggles its answer open/closed.
document.querySelectorAll('.dining-faq__q').forEach((btn) => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.dining-faq__item');
    if (!item) return;
    const open = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
});
